import type { Loading } from "@/lib/loading"
import { processIsReady } from "@/lib/loading/processIsReady"

export const dependenciesReady = (
  {
    loading,
  }: {
    loading: Loading.ContextData
  },
  { dependencies }: Loading.Config
): boolean => {
  return dependencies.every((dependency) => {
    return processIsReady({ loading }, dependency)
  })
}
